module.exports = __webpack_public_path__ + "img/doppio-impianto.c7a3b988.jpg";